module.exports = __webpack_public_path__ + "static/media/Contenders.c53bba5b.svg";